import _taggedTemplateLiteral from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
import orderTypeFragment from '../../fragments/orderType/orderTypeInfo';
export const getOrderTypesQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query GetOrderTypes {\n    orderTypes {\n      ...orderTypeInfo\n    }\n    giftClasses {\n      ...orderTypeInfo\n    }\n  }\n  ", "\n"])), orderTypeFragment);
export const getOrderTypesQueryOptions = function () {
  let skip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    //fetchPolicy: 'cache-and-network',
    fetchPolicy: 'no-cache',
    skip
  };
};